
import {HttpService} from '.'

export class PostHttpService{

    getHeaders(){
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");
        return headers
    }

    static async savePostPhotoGallery(post,url){

        let body = {
            "post": post,
            "url": url
        }

        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`postapi/photogallery/${body.id}`,body);
        }
        else
             response = await service.post('postapi/photogallery/',body);
        return response;
    }

    static async loadPostPhotoGalleries(id){
        // var query = `?size=50`;
        
        var service = new HttpService();
        var response = await service.get(`postapi/photogallery/?post=${id}`,null);
        return response;
    }

    static async loadPostVideoGalleries(id){
        // var query = `?size=50`;
        
        var service = new HttpService();
        var response = await service.get(`postapi/post/videogallery/?post=${id}`,null);
        return response;
    }

    static async savePostVideoGallery(post,url,category){

        let body = {
            "post": post,
            "url": url
        }

        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`postapi/post/videogallery/${body.id}`,body);
        }
        else
             response = await service.post('postapi/post/videogallery/',body);
        return response;
    }

    static async updatePostVideoGallery(id, post, url) {
        const body = {
            post: post,
            url: url
        };

        const service = new HttpService();
        const response = await service.put(`postapi/post/videogallery/${id}/`, body);
        return response;
    }

    
}